import React, {useEffect, useMemo} from "react";

import {
    Drawer,
    Divider
} from "antd";

import {
    useDispatch,
    useSelector
} from "react-redux";

import {
    closeDrawer,
    loadConversationSuccess
} from "../../../../../store/reducers/notification/conversation/conversationNotificationSlice";

import ConversationNotificationService
    from "../../../../../servics/notification/conversation/conversationNotificationService";

import ConversationHeader from "./ConversationHeader";
import ConversationMessages from "./ConversationMessages";
import ConversationOfferPanel from "./ConversationOfferPanel";
import ConversationAgreementPanel from "./ConversationAgreementPanel";
import AgreementFooter from "./AgreementFooter";
import MessageCounter from "../message/MessageCounter";
import MessageReplyBox from "./MessageReplyBox";
import OfferReplyBox from "./OfferReplyBox";
import ConversationOfferService from "../../../../../servics/notification/conversation/ConversationOfferService";
import TransactionService
    from "../../../../../servics/notification/transaction/TransactionService";

const ConversationDrawer = ({
                                onOpenTransaction
                            }) => {

    const dispatch = useDispatch();

    const {
        drawerOpen,
        loadingConversation,
        selectedConversation,
        messages = [],
        offer,
        buyerMessagesCount,
        sellerMessagesCount
    } = useSelector(
        state => state.conversationNotification
    );

    const refreshConversation = async () => {

        if (!inquiryId) {
            return;
        }

        try {

            const [
                conversationData,
                messagesData,
                offerData
            ] = await Promise.all([

                ConversationNotificationService
                    .getConversation(inquiryId),

                ConversationNotificationService
                    .getMessages(inquiryId),

                ConversationOfferService
                    .getCurrentOffer(inquiryId)

            ]);


            let agreementData = null;


            /*
             * ======================================================
             * OFFER ACCEPTED
             * ======================================================
             *
             * Une offre acceptée peut avoir généré un Agreement.
             *
             * Le vendeur ne doit pas ouvrir le parcours de
             * finalisation.
             *
             * L'acheteur, lui, doit pouvoir le reprendre même
             * s'il ferme puis rouvre la notification.
             */

            if (
                offerData?.status === "ACCEPTED" &&
                offerData?.agreementId &&
                isBuyer
            ) {

                agreementData =
                    await TransactionService
                        .getAgreement(
                            inquiryId,
                            offerData.agreementId
                        );

            }


            dispatch(
                loadConversationSuccess({
                    conversation:
                    conversationData,

                    messages:
                    messagesData,

                    offer:
                    offerData,

                    agreement:
                    agreementData,

                    inquiryId
                })
            );


            /*
             * ======================================================
             * OPEN TRANSACTION FOR BUYER
             * ======================================================
             */

            console.log(
                "TRANSACTION DETECTION",
                {
                    isBuyer,
                    offerStatus: offerData?.status,
                    offerId: offerData?.id,
                    agreementId: offerData?.agreementId
                }
            );

            if (
                isBuyer &&
                agreementData &&
                offerData?.status === "ACCEPTED"
            ) {
                console.log(
                    "ACCEPTED OFFER -> OPEN TRANSACTION",
                    {
                        inquiryId,
                        agreementId:
                        offerData.agreementId
                    }
                );

                onOpenTransaction?.({
                    inquiryId,

                    agreementId:
                    agreementData.id,

                    offerId:
                    offerData.id
                });

            }

        } catch (error) {

            console.error(
                "Erreur lors du chargement de la conversation",
                error
            );

        }
    };

    const tenantUser = useSelector(
        state => state.tenantUser.tenantUser
    );

    const currentUserId =
        tenantUser?.id;

    const inquiryId =
        selectedConversation?.inquiryId;

    useEffect(() => {
        if (!drawerOpen || !inquiryId) {
            return;
        }

        refreshConversation();
    }, [drawerOpen, inquiryId]);

    /*
     * IMPORTANT :
     * MarketplaceConversation ne contient pas
     * selectedConversation.inquiry.
     *
     * On utilise donc directement buyerId / sellerId.
     */
    const isSeller =
        selectedConversation?.sellerId === currentUserId;

    const isBuyer =
        selectedConversation?.buyerId === currentUserId;

    const archived =
        selectedConversation?.status === "ARCHIVED";


    const buyerCanReply =
        buyerMessagesCount < 3;

    const sellerCanReply =
        sellerMessagesCount < 3;

    /*
     * Dernière offre disponible dans les messages.
     */

    // const offer = useMemo(() => {
    //
    //     const offerMessages =
    //         messages.filter(
    //             message =>
    //                 message.messageType === "SELLER_OFFER" ||
    //                 message.messageType === "COUNTER_OFFER"
    //         );
    //
    //     if (offerMessages.length === 0) {
    //         return null;
    //     }
    //
    //     return offerMessages[
    //     offerMessages.length - 1
    //         ];
    //
    // }, [messages]);

    /*
     * Dernier accord disponible dans les messages.
     */
    const agreement = useMemo(() => {

        const agreementMessages =
            messages.filter(
                message =>
                    message.messageType === "AGREEMENT"
            );

        if (agreementMessages.length === 0) {
            return null;
        }

        return agreementMessages[
        agreementMessages.length - 1
            ];

    }, [messages]);

    // const canBuyerAccept =
    //     isBuyer &&
    //     agreement?.status === "PAYMENT_PENDING";

    const canBuyerActOnOffer =
        isBuyer &&
        offer &&
        !agreement;


    const handleClose = () => {

        dispatch(
            closeDrawer()
        );

    };

    // const refreshConversation = async () => {
    //
    //     if (!inquiryId) {
    //         return;
    //     }
    //
    //     const [
    //         conversationData,
    //         messagesData,
    //         offerData
    //     ] = await Promise.all([
    //
    //         ConversationNotificationService
    //             .getConversation(inquiryId),
    //
    //         ConversationNotificationService
    //             .getMessages(inquiryId),
    //
    //         ConversationOfferService
    //             .getCurrentOffer(inquiryId)
    //
    //     ]);
    //
    //     dispatch(
    //         loadConversationSuccess({
    //             conversation: conversationData,
    //             messages: messagesData,
    //             offer: offerData,
    //             inquiryId
    //         })
    //     );
    // };

    const handleSendMessage = async (
        payload
    ) => {

        if (!inquiryId) {
            return;
        }

        await ConversationNotificationService
            .sendMessage(
                inquiryId,
                payload
            );

        await refreshConversation();
    };

    const handleSendOffer = async (payload) => {
        if (!inquiryId) return;

        await ConversationOfferService.createOffer(
            inquiryId,
            payload
        );

        await refreshConversation();
    };

    const handleAcceptOffer = async () => {
        if (!inquiryId || !offer?.id) {
            return;
        }

        try {
            const acceptedOffer =
                await ConversationOfferService.acceptOffer(
                    inquiryId,
                    offer.id
                );

            console.log("ACCEPTED OFFER", acceptedOffer);

            await refreshConversation();

            if (
                acceptedOffer?.status === "ACCEPTED" &&
                acceptedOffer?.agreementId
            ) {
                console.log(
                    "OPENING TRANSACTION",
                    {
                        inquiryId,
                        agreementId: acceptedOffer.agreementId,
                        offerId: acceptedOffer.id
                    }
                );

                onOpenTransaction?.({
                    inquiryId,
                    agreementId: acceptedOffer.agreementId,
                    offerId: acceptedOffer.id
                });
            }
        } catch (error) {
            console.error(
                "Erreur lors de l'acceptation de l'offre",
                error
            );
        }
    };

    const handleRejectOffer = async () => {

        if (!inquiryId || !offer?.id) {
            return;
        }

        await ConversationOfferService.rejectOffer(
            inquiryId,
            offer.id
        );

        await refreshConversation();
    };

    const handleUpdateProposal = async (
        payload
    ) => {

        if (!inquiryId || !offer?.id) {
            return;
        }

        await ConversationOfferService.updateProposal(
            inquiryId,
            offer.id,
            payload
        );

        await refreshConversation();
    };

    const handleDeclineOffer = async () => {

        if (!inquiryId) {
            return;
        }

        await ConversationNotificationService
            .declineOffer(
                inquiryId
            );

        await refreshConversation();
    };

    if (!selectedConversation) {
        return null;
    }

    console.log("CONVERSATION DEBUG", {
        currentUserId,
        buyerId: selectedConversation?.buyerId,
        sellerId: selectedConversation?.sellerId,
        conversationStatus: selectedConversation?.status,
        isBuyer,
        isSeller,
        archived,
        offerId: offer?.id,
        agreementId: offer?.agreementId,
        sellerMessagesCount,
        sellerCanReply
    });

    return (
        <Drawer
            title={null}
            open={drawerOpen}
            onClose={handleClose}
            destroyOnClose
            width={650}
            styles={{
                body: {
                    padding: 0,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%"
                }
            }}
        >

            <ConversationHeader
                conversation={selectedConversation}
                loading={loadingConversation}
                onClose={handleClose}
                buyerMessages={
                    buyerMessagesCount
                }
                sellerMessages={
                    sellerMessagesCount
                }
            />

            <Divider
                style={{ margin: 0 }}
            />

            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: 20,
                    background: "#fafafa"
                }}
            >

                <MessageCounter
                    buyerMessages={
                        buyerMessagesCount
                    }
                    sellerMessages={
                        sellerMessagesCount
                    }
                />

                <ConversationMessages />

            </div>

            {
                offer && (
                    <>
                        <Divider
                            style={{ margin: 0 }}
                        />

                        <ConversationOfferPanel
                            offer={offer}
                            currentUserId={currentUserId}
                            isBuyer={isBuyer}
                            isSeller={isSeller}
                            loading={loadingConversation}
                            onModify={handleUpdateProposal}
                            onAccept={handleAcceptOffer}
                            onReject={handleRejectOffer}
                        />
                    </>
                )
            }

            {
                agreement && (
                    <>
                        <Divider
                            style={{ margin: 0 }}
                        />

                        <ConversationAgreementPanel
                            agreement={agreement}
                        />
                    </>
                )
            }

            {
                !archived &&
                isSeller && (
                    <>
                        <Divider
                            style={{ margin: 0 }}
                        />

                        <MessageReplyBox
                            inquiryId={inquiryId}
                            loading={
                                loadingConversation
                            }
                            canReply={
                                sellerCanReply
                            }
                            onSendMessage={
                                handleSendMessage
                            }
                        />
                    </>
                )
            }

            {!archived && isSeller && !offer && (
                <OfferReplyBox
                    inquiryId={inquiryId}
                    loading={loadingConversation}
                    onSendOffer={handleSendOffer}
                />
            )}

            {
                !archived &&
                isBuyer && (
                    <>
                        <Divider
                            style={{ margin: 0 }}
                        />

                        <MessageReplyBox
                            inquiryId={inquiryId}
                            loading={
                                loadingConversation
                            }
                            canReply={
                                buyerCanReply
                            }
                            onSendMessage={
                                handleSendMessage
                            }
                        />

                        {/*<AgreementFooter*/}
                        {/*    offer={offer}*/}
                        {/*    canAccept={*/}
                        {/*        canBuyerActOnOffer*/}
                        {/*    }*/}
                        {/*    loading={*/}
                        {/*        loadingConversation*/}
                        {/*    }*/}
                        {/*    onAccept={*/}
                        {/*        handleAcceptOffer*/}
                        {/*    }*/}
                        {/*    onDecline={*/}
                        {/*        handleDeclineOffer*/}
                        {/*    }*/}
                        {/*/>*/}
                    </>
                )
            }

        </Drawer>
    );
};

export default ConversationDrawer;